import React, { useEffect } from "react";
import FranchiseOrdersListing from "./FranchiseOrdersListing";
import { columnTypes } from "src/components/UI/atoms/ATMTable/ATMTable";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/redux/store";
import {
  setPage,
  setRowsPerPage,
  setSearchValue,
  setIsTableLoading,
  setItems,
  setTotalItems,
} from "src/redux/slices/FranchiseOrderSlice";
import { useGetAllOfflineOrderDataQuery } from "src/services/OfflineOrderService";
import { formatedDateTimeIntoIst } from "src/utils/formUtils/dateTimeFormate";
import { Tooltip } from "@mui/material";
import { useParams } from "react-router-dom";

type Props = {};

const FranchiseOrdersListingWrapper = (props: Props) => {
  const dispatch = useDispatch();
  const { items, totalItems, page, rowsPerPage, searchValue, isTableLoading } =
    useSelector((state: RootState) => state.franchiseOrder);

  const { franchiseId } = useParams()
  const { data, isLoading, isFetching } = useGetAllOfflineOrderDataQuery({
    limit: rowsPerPage,
    searchValue: searchValue,
    params: ["name","mobile"],
    page: page,
    filterBy: [
      {
        fieldName: "userId",
        value: franchiseId 

      }
    ],
    dateFilter: {},
    orderBy: "createdAt",
    orderByValue: -1,
    isPaginationRequired: true,
  });

  // Setting Module Data
  useEffect(() => {
    if (isLoading || isFetching) {
      dispatch(setIsTableLoading(true));
    } else {
      dispatch(setItems(data?.data || []));
      dispatch(setIsTableLoading(false));
      dispatch(setTotalItems(data?.totalItem || 0));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, isLoading, isFetching]);


  const columns: columnTypes[] = [
    {
      field: "createdAt",
      headerName: "Date - Time",

      extraClasses: "min-w-[150px] py-1 min-w-[150px]",
      flex: "flex-[1.5_1.5_0%]",
      renderCell: (row: any) => (
        <div>
          <div className="text-slate-700 font-medium text-[14px]">
            {formatedDateTimeIntoIst(row.createdAt, "DD MMM yyyy")}
          </div>
          <div className="text-[12px] font-medium text-slate-400">
            {formatedDateTimeIntoIst(row.createdAt, "hh:mm A")}
          </div>
        </div>
      ),
    },
    {
      field: "orderNumber",
      headerName: "Order Number",
      flex: "flex-[1_1_0%]",
      renderCell: (row: any) => (
        row?.orderNumber ? <div className="bg-stone-100 p-[3px] flex justify-between items-center rounded-xl  text-xs gap-4 cursor-pointer">
          {row?.orderNumber}
        </div> : '-'
      ),
    },
   
    {
      field: "name",
      headerName: "Name",
      flex: "flex-[1.5_1.5_0%]",
      renderCell: (row: any) =>
        <Tooltip title={row?.name}>
          <div className="capitalize text-[13px]"> {row?.name} </div>
        </Tooltip>
    },
    {
      field: "email",
      headerName: "Email",
      flex: "flex-[1.5_1.5_0%]",
      renderCell: (row: any) => (
        <Tooltip title={row?.email}>
          <div className="capitalize text-[13px]"> {row?.email} </div>
        </Tooltip>
      ),
    },
    {
      field: "mobile",
      headerName: "Mobile",
      flex: "flex-[1.5_1.5_0%]",
      renderCell: (row: any) => (
        <div className="capitalize text-[13px]"> {row?.mobile} </div>
      ),
    },
    {
      field: "orderTotal",
      headerName: "Amount",
      flex: "flex-[1.5_1.5_0%]",
      renderCell: (row: any) => <div>&#8377; {row?.orderTotal}</div>,
    },
    {
      field: "dueAmt",
      headerName: "Remaining Fees",
      flex: "flex-[1.5_1.5_0%]",
      renderCell: (row: any) => <div>&#8377; {row?.dueAmt}</div>,
    },
  ];

  return (
    <div>
      <FranchiseOrdersListing
        columns={columns}
        rows={items}
        paginationProps={{
          isTableLoading,
          totalItems,
          page,
          rowsPerPage,
          searchValue,
          setPage: (newPage) => dispatch(setPage(newPage)),
          setRowsPerPage: (newRowsPerPage) =>
            dispatch(setRowsPerPage(newRowsPerPage)),
          setSearchValue: (newValue) => dispatch(setSearchValue(newValue)),
        }}
      />
    </div>
  );
};

export default FranchiseOrdersListingWrapper;
